import { render, staticRenderFns } from "./AddressNormalizationList.vue?vue&type=template&id=12aa48a0"
import script from "./AddressNormalizationList.vue?vue&type=script&lang=js"
export * from "./AddressNormalizationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports